export default __webpack_public_path__ + "static/media/ParmarLogo.06603637.png";